(function() {
    var currentProductId = "{{ product.id }}";
    window.bundlerProducts = [];

    document.addEventListener('bundler:loaded', function(e) {
      window.bndlr.preventBundlerCheckout();

      async function getBundledProductData(url) {
        try {
          const response = await fetch(`${url}?view=object`);
          const jsonResponse = await response.json();

          window.bundlerProducts.push(jsonResponse)
        } catch(e) {
          console.error('error unable to fetch product object', e);
        }

      }

      function delayPush(item, index) {
        let timeout = window.setTimeout(() => {
         console.log('cdebug bundle atc', item, 1000 * index);
          _learnq.push(['track', 'Added to Cart', item]);
          window.clearTimeout(timeout);
        }, 1000 * index)
      }

      /**
       * This script is used to fetch data from the product page of each of the bundled products
       * product.object.liquid is a template that is used to get product details via ajax.
       * The product details that results from that template is used as an object for Klaviyo tracking for bundled products.
       */
      const bndlrTimeout = window.setTimeout(function() {
        const getBundlerProducts = Array.from(document.querySelectorAll('.bndlr-product-image-url'));
        const bndlrATC = document.querySelector('.bndlr-add-to-cart');
        
        if(getBundlerProducts.length > 0) {
          getBundlerProducts.forEach(element => {
            if(element && element.href) {
              getBundledProductData(element.href)
            }
          });
        }

        bndlrATC && bndlrATC.addEventListener('click', function(e) {
          if(window.bundlerProducts.length > 0) {
            window.bundlerProducts.forEach((item, index) => {

              delayPush(item, index + 1)

            })
          }
        });

        window.clearTimeout(bndlrTimeout);
      }, 1500)
      
    });

    document.addEventListener('product:added', function(e) {
      window.bndlr.preventBundlerCheckout();
    });

    document.addEventListener('bundler:total_cart_values', function(e) {
      const newCart = 'original_cart_object' in e.detail ? e.detail['original_cart_object'].items : [];

      //Update CartJS with bundler callback
      CartJS.cart.items = newCart;

      
      //Update Cart Drawer
      let updateCartDrawer = new CustomEvent('update-cart-drawer', {
        detail: e.detail
      });

      //document.dispatchEvent(updateCartDrawer);
      // The e.details will contain the object with the necessary info. Also, a thing to note here is that the values are always in cents, not in dollars, therefore you have to divide them by 100 to get dollars.
    });


  })();